<template lang="pug">
  ._layoutLogin
    template(v-if="loading")
      .authBox
        TheLogo.logo
        el-alert(title="Carregando sistema, por favor aguarde.", type="info" :closable="false")
    template(v-else-if="!device && !ignoreDevice")
      .authBox
        TheLogo.logo
        el-alert(title="Não foi possível determinar o navegador que você está utilizando. Por favor, tente novamente ou entre em contato com seu supervisor.", type="error" :closable="false")
        .form
          el-button.form-button(type="primary" round @click="reload") Tentar novamente
    template(v-else-if="invalidDevice")
      .authBox
        TheLogo.logo
        el-alert(title="O seu navegador atual não possui suporte. Por favor, acesse o App através do Google Chrome", type="error" :closable="false")
    template(v-else-if="invalidEnv")
      .authBox
        TheLogo.logo
        el-alert(title="Este ambiente não deve ser usado sem supervisão de um administrador. Por favor, acesse a plataforma oficial através do link abaixo", type="error" :closable="false")
        .form
          el-button.form-button.form-button--outlined(type="primary" round @click="goOfficial") coach.jbs.emiolo.com.br

    template(v-else)
      OfflineCompanion
      GlobalWrapper
        nuxt
</template>

<script>
import OfflineCompanion from '~/components/OfflineCompanion'
import TheLogo from '~/components/global/TheLogo'
import GlobalWrapper from '../components/GlobalWrapper'
export default {
  name: 'Login',
  components: { OfflineCompanion, TheLogo, GlobalWrapper },
  data: () => ({
    device: null,
    loading: true,
    ignoreEnv: false,
    ignoreDevice: false,
    env: null,
  }),
  computed: {
    invalidEnv() {
      if (this.ignoreEnv) return false
      const allowedEnvs = [
        'http://localhost:3001',
        'http://localhost:3002',
        'https://coach.jbs.emiolo.com.br',
      ]
      return !allowedEnvs.includes(this.env)
    },
    invalidDevice() {
      if (this.ignoreDevice) return false
      return !this.device?.client?.name?.toLowerCase?.().includes('chrome')
    },
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 10000)
    this.loadEnv()
    this.loadDevice()
    this.loading = false
  },
  methods: {
    reload() {
      window.location.reload(true)
    },
    loadEnv() {
      if (this.$route.query?.ignoreEnv !== undefined) {
        this.ignoreEnv = true
        this.$telemetry.pushEvent({
          category: 'auth',
          name: 'layout',
          action: 'ignoreEnv',
        })
        return
      }
      this.env = window.location.origin
    },
    loadDevice() {
      if (this.$route.query?.ignoreDevice !== undefined) {
        this.ignoreDevice = true
        this.$telemetry.pushEvent({
          category: 'auth',
          name: 'layout',
          action: 'ignoreDevice',
        })
        return
      }
      try {
        this.device = this.$telemetry.getDevice()
      } catch (error) {
        this.$telemetry.pushEvent({
          category: 'auth',
          name: 'layout',
          action: 'fetchDevice',
          error,
        })
      }
    },
    goOfficial() {
      window.location.href = 'https://coach.jbs.emiolo.com.br'
    },
  },
}
</script>

<style lang="sass">
html
  height: 100%
body
  --bgColor: #EBEBEB
  --iconColor: #FFFFFF
  --iconActiveColor: #30BAE3
  --primaryColor: #232378
  --textColor: #767676
  --textHighlightColor: #232323
  --backgroundSteak: #ffaaa5
  --darkBlueColor: #1A4982
  background-color: var(--bgColor)
  color: var(--textColor)
  font:
    family: 'Montserrat', sans-serif
    size: 16px
  min-height: 100vh
#__nuxt, #__layout
  min-height: 100vh
._layoutLogin
  align-items: center
  display: flex
  justify-content: center
  min-height: 100vh
</style>

<style lang="sass" scoped>
.authBox
  background-color: #FFFFFF
  padding: 16px
  display: flex
  flex-direction: column
  align-items: center
  width: 80%
  .form
    padding-top: 8px
    &-button
      background-color: var(--primaryColor)
      border-color: var(--primaryColor)
      margin: 8px 0
      text-transform: uppercase
      &--inverse
        border: 0
        background: transparent
        color: var(--primaryColor)
        text-transform: none
      &--outlined
        border: 1px solid var(--primaryColor)
        color: var(--primaryColor)
        background: transparent
.logo
  fill: transparent
  width: 120px
  height: auto
  margin-bottom: 16px
</style>
